// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hero-image-caption-module__wrapper__3inEx","divider":"hero-image-caption-module__divider__3Erdt"};